import type { ButtonHTMLAttributes, ReactNode } from 'react';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  loading?: boolean;
  full?: boolean;
};

export function Button({
  variant = 'primary',
  loading = false,
  full = false,
  children,
  className = '',
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      disabled={disabled || loading}
      className={`btn btn--${variant} ${full ? 'btn--full' : ''} ${className}`}
    >
      {loading ? <Spinner inline /> : children}
    </button>
  );
}

export function Spinner({ inline = false }: { inline?: boolean }) {
  return <span className={inline ? 'spinner spinner--inline' : 'spinner'} aria-label="Загрузка" />;
}

export function ErrorBanner({ children, onRetry }: { children: ReactNode; onRetry?: () => void }) {
  return (
    <div className="banner banner--error">
      <span>{children}</span>
      {onRetry && (
        <button className="banner__action" onClick={onRetry}>
          Ещё раз
        </button>
      )}
    </div>
  );
}

export function InfoBanner({ children }: { children: ReactNode }) {
  return <div className="banner banner--info">{children}</div>;
}

export function Screen({ children }: { children: ReactNode }) {
  return <div className="screen">{children}</div>;
}

export function CenterState({ children }: { children: ReactNode }) {
  return <div className="center-state">{children}</div>;
}
